import { atom } from 'recoil';

export const aiModalOpenAtom = atom({
  key: 'aiModalOpenAtom',
  default: false,
});
